import { createDocumentsAction, createDocumentsReducer } from 'prismic-utils'
import { Predicates } from 'prismic-javascript'

// Constants
const NAMESPACE = 'app/customTagPages'

// Selectors
export * from './selectors'

// Action
export const fetchCustomTagPages = (repo, siteID, { previewToken } = {}) => (
  createDocumentsAction(NAMESPACE, {
    repository: repo,
    type: 'tag_pages',
    token: previewToken,
    pageSize: 999,
    predicates: [
      Predicates.at('my.tag_pages.site', siteID)
    ]
  })
)

// Reducer
// If there are no tag pages, instead of returning a response with no matching
// documents, it actually returns a 400. Meaning during the build, pages status is
// "failed", so it tries again in the client causing issues.
const fetchFailure = (state) => ({
  status: 'fetched',
  data: []
})

export default createDocumentsReducer(NAMESPACE, { fetchFailure })
